export const uiTypes = {
  TEXT: 'text',
  TEXTAREA: 'textarea',
  SELECTBOX: 'selectbox',
  CHECKBOX: 'checkbox',
  RADIO: 'radio',
} as const;

export type UiType = typeof uiTypes[keyof typeof uiTypes];
